import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import { FiX } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import {
  getViewProfile,
  updateProfile,
} from "../../../redux/slices/profileSlice";

const EducationModal = ({
  show,
  onHide,
  value,
  onSave,
  isApplyPage = false,
  shouldUpdateProfile = false,
}) => {
  const dispatch = useDispatch();
  const store = useSelector((state) => state.profile);

  const [selectedOption, setSelectedOption] = useState("");
  const [error, setError] = useState("");

  // const educationOptions = [
  //   { value: "ADN", label: "ADN (Associate Degree in Nursing)" },
  //   { value: "BSN", label: "BSN (Bachelor of Science in Nursing)" },
  //   { value: "MSN", label: "MSN (Master of Science in Nursing)" },
  //   { value: "DNP", label: "DNP (Doctor of Nursing Practice)" },
  //   { value: "PhD", label: "PhD (Doctor of Philosophy in Nursing)" },
  // ];
  const educationOptions = [
    {
      value: "No formal education required",
      label: "No Formal Education Required",
    },
    { value: "High School Diploma / GED", label: "High School Diploma / GED" },
    { value: "CNA Certification", label: "CNA Certification" },
    { value: "LPN/LVN Certificate", label: "LPN / LVN Certificate" },
    {
      value: "Bachelor's in Health Administration (BHA)",
      label: "Bachelor's in Health Administration (BHA)",
    },
    {
      value: "Bachelor's in a Related Field",
      label: "Bachelor's in a Related Field",
    },
    {
      value: "Master's in Health Administration (MHA)",
      label: "Master's in Health Administration (MHA)",
    },
    { value: "ADN", label: "ADN (Associate Degree in Nursing)" },
    { value: "BSN", label: "BSN (Bachelor of Science in Nursing)" },
    { value: "MSN", label: "MSN (Master of Science in Nursing)" },
    { value: "DNP", label: "DNP (Doctor of Nursing Practice)" },
    { value: "PhD", label: "PhD (Doctor of Philosophy in Nursing)" },
  ];
  useEffect(() => {
    if (show) {
      // dispatch(getViewProfile());
    }
  }, [show, dispatch]);

  // Load existing value
  // useEffect(() => {
  //   if (!show) return;

  //   const current = store?.profileItem?.data?.nurseProfile?.education;

  //   if (current) {
  //     setSelectedOption(current);
  //   }
  // }, [show, store?.profileItem]);
  useEffect(() => {
    if (!show) return;

    if (isApplyPage) {
      setSelectedOption(value || "");
    } else {
      const current = store?.profileItem?.data?.nurseProfile?.education;
      setSelectedOption(current || "");
    }
  }, [show, value, isApplyPage, store]);

  const handleSelect = (value) => {
    setSelectedOption(value);
    setError("");
  };

  // const handleSave = () => {
  //   if (!selectedOption) {
  //     setError("Please select your education level");
  //     return;
  //   }

  //   if (isApplyPage) {
  //     // ✅ LOCAL UPDATE
  //     onSave(selectedOption);
  //     onHide();
  //   } else {
  //     // ✅ API CALL (Profile page)
  //     const formData = new FormData();

  //     formData.append(
  //       "name",
  //       store?.profileItem?.data?.name ||
  //         store?.profileItem?.data?.full_name ||
  //         "",
  //     );

  //     formData.append("education", selectedOption);

  //     dispatch(updateProfile(formData));
  //   }
  // };
  const handleSave = () => {
    if (!selectedOption) {
      setError("Please select your education level");
      return;
    }

    if (isApplyPage) {
      // ✅ ALWAYS update local
      onSave(selectedOption);

      // 🔥 ONLY call API if empty before
      if (shouldUpdateProfile) {
        const formData = new FormData();

        formData.append(
          "name",
          store?.profileItem?.data?.name ||
            store?.profileItem?.data?.full_name ||
            "",
        );

        formData.append("education", selectedOption);

        dispatch(updateProfile(formData));
      }

      onHide();
    } else {
      // ✅ Profile page → always API
      const formData = new FormData();

      formData.append(
        "name",
        store?.profileItem?.data?.name ||
          store?.profileItem?.data?.full_name ||
          "",
      );

      formData.append("education", selectedOption);

      dispatch(updateProfile(formData));
    }
  };
  useEffect(() => {
    if (store?.actionFlag === "PROFILE_UPDT_SCS") {
      onHide();
    }
  }, [store?.actionFlag]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      dialogClassName="custom-modal profile-other-details-modal"
    >
      <Modal.Header>
        <h5 className="modal-title">
          What is your highest nursing education level?
        </h5>

        <Button className="close-btn" onClick={onHide}>
          <FiX size={24} />
        </Button>
      </Modal.Header>

      <Modal.Body>
        <div className="radio-options">
          <div className="row">
            {educationOptions.map((option) => (
              <div
                key={option.value}
                className={`radio-option col-lg-6 ${
                  selectedOption === option.value ? "selected" : ""
                }`}
                onClick={() => handleSelect(option.value)}
              >
                <div className="contentwrap">
                  <input
                    type="radio"
                    checked={selectedOption === option.value}
                    readOnly
                  />

                  <label className="radio-label">{option.label}</label>
                </div>
              </div>
            ))}
          </div>
        </div>

        {error && <div className="error-message mt-2">{error}</div>}

        <div className="text-center mt-4">
          <Button
            className="btn-primary px-4"
            onClick={handleSave}
            disabled={store?.isLoading || !selectedOption}
          >
            {store?.isLoading ? "Saving..." : "Save"}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default EducationModal;
